import { useContext, useEffect, useRef, useState } from "react";
import NiceModal from "@ebay/nice-modal-react";
import ModalBase from "modals/base/ModalBase";
import TabView from "layouts/view/TabView";
import { useTranslation } from "react-i18next";
import TabViewChild from "layouts/view/TabViewChild";
import { validateInputs } from "shared/utils/Utils";
// import { medusaRequester } from "App";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import InputText from "components/inputs/InputText";
import InputPassword from "components/inputs/InputPassword";
import ButtonEclipse from "components/buttons/ButtonEclipse";
import {
  emailFormat,
  mobileNoFormat,
  passwordFormat,
  textFormat,
  userNameFormat,
} from "InitialData/regExp";
import InputEmail from "components/inputs/InputEmail";
import style from "./SignModal.module.css";
import Center from "layouts/wrapper/Center";
import Inline from "layouts/container/Inline";
import P from "components/P";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import Dummy from "components/Dummy";
import { CButton } from "@coreui/react";
import Terms from "./signUp/Terms";
import CheckCircleGroup from "components/inputs/checkBox/CheckCircleGroup";
import { ToastContainer, toast } from "react-toastify";
import CustomButton from "components/buttons/CustomButton";
import { useDispatch } from "react-redux";
import ReactLoading from "react-loading";
import Loading from "modals/base/Loading";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import InputFile from "components/inputs/InputFile";
import { useNavigate } from "react-router-dom";
import { fileRequester, storeRequester } from "App";
import clsx from "classnames";
import Flex from "layouts/flex/Flex";
import documentImg from "resources/img/document.svg"
import phoneImg from "resources/img/phone.svg"
import messageImg from "resources/img/message.svg"
import HighlightedText from "components/inputs/HighlightedText";


const MemberSignTabModal = NiceModal.create((props, ref) => {
  const modal = useRef();
  const { isMobile } = useContext(BrowserDetectContext);
  const { t } = useTranslation();
  const [withHeader, withFooter] = [false, false];
  const [width, height] = [
    isMobile ? "100%" : "min(1200px, 80%)",
    isMobile ? "100vh" : "80%",
  ];
  const withCloseButton = true;
  const clickOutsideToClose = true;
  const title = "";
  const buttonText = "close";
  const inputsSignUp = useRef([]);
  const inputTabIndex = useRef();
  const tabViewRef = useRef();
  const [tabIndex, setTabIndex] = useState();
  const [selectedList, setSelectedList] = useState([]);
  const [totalCount, setTotalCount] = useState();
  const [agree, setAgree] = useState("");
  const [userName, setUserName] = useState();
  const [password, setPassword] = useState();
  const [signUpResult, setSignUpResult] = useState(false);
  const dispatch = useDispatch();
  const rowIndex = [
    {
      id: 1,
      accent: true,
      text: t("termsOfUseAgree"),
      header: t("termsOfUse"),
    },
    {
      id: 2,
      accent: true,
      privacy: true,
      text: t("privacyPolicyAgree"),
      header: t("privacyPolicy") + t("useToInfo"),
    },
  ];
  const [businessAddress, setBusinessAddress] = useState();
  const [validationResult, setValidationResult] = useState(false);
  const [businessCertificate, setBusinessCertificate] = useState(null);
  const [businessRetail, setBusinessRetail] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // 모달이 열렸을 때 body 스크롤 비활성화
    document.body.style.overflow = "hidden";

    // 모달이 닫힐 때 복구
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    selectedList.map((data, index) => {
      if (data.accent && selectedList.length >= 2) {
        setAgree(true);
      } else {
        setAgree(false);
      }
      if (selectedList.length >= 3) {
        setAgree(true);
      }
    });
  }, [selectedList]);
  const [duplicate, setDuplicate] = useState(true);

  const [signUpData, setSignUpData] = useState({
    email: "",
    password: "",
    first_name: "",
    last_name: "",
    phone: "",
    businessMutual: "",
    businessNumber: "",
    postal_code: "",
    businessAddress: "",
    businessAddressDetail: "",
    businessName: "",
    businessPhone: "",
    businessEmail: "",
    businessDetail: "",
    businessType: "",
    businessCertificate: "",
    businessRetail: "",
    recommender: "" // 추가
  });

  const onTabChange = (activeTabIndex) => {
    setTabIndex(activeTabIndex);
  };

  const onNextBtnClick = () => {
    signUp();
  };

  const onShoppingClick = () => {
    // signIn();
    modal.current.close();
  };

  const signIn = () => {
    modal.current.close();
    navigate("/login");
  };

  const isEmpty = (value) => !value || value.trim() === "";

  const getRecommenderFromPartnerLink = () => {
    const partnerLink = localStorage.getItem('partnerLink'); // 앞서 정의한 PARTNER_LINK_KEY 상수 사용

    if (!partnerLink) return null;

    // YYMMDD 부분(마지막 6자리)을 제외한 나머지가 recommender ID
    return partnerLink.slice(0, -6);
  };

  const signUp = async () => {
    let certificateUrl = "";
    let retailUrl = "";
    // const data = {
    //   email: "",
    //   password: "",
    //   first_name: "",
    //   last_name: "",
    //   phone: "",
    //   businessMutual: "",
    //   businessNumber: "",
    //   businessAddress: "",
    //   businessName: "",
    //   businessPhone: "",
    //   businessEmail: "",
    //   businessDetail: "",
    //   businessType: "",
    //   businessCertificate: "",
    //   businessRetail: "",
    // };

    const data = {
      email: "",
      password: "",
      first_name: "",
      last_name: "",
      phone: "",
    };

    // 입력 값 공백 확인
    const inputLabels = [
      "이메일",
      "비밀번호",
      "이름",
      "전화번호",
    ];

    for (let i = 0; i <= 3; i++) {
      const inputValue = inputsSignUp.current[i].getValue();
      if (isEmpty(inputValue)) {
        toast.error(`${inputLabels[i]} 입력값이 비어있습니다.`, {
          autoClose: 1000,
          position: toast.POSITION.BOTTOM_CENTER,
        });
        inputsSignUp.current[i].focus();
        return; // 빈 값이 있는 경우 함수 종료
      }
    }

    // 사업자등록증 업로드
    // if (businessCertificate !== null) {
    //   const formData = new FormData();
    //   formData.append("files", businessCertificate);

    //   certificateUrl = (await fileRequester.upload(formData)).uploads[0].url;
    // }

    // 소매인지정서 업로드
    // if (businessRetail !== null) {
    //   const formData = new FormData();
    //   formData.append("files", businessRetail);
    //   retailUrl = (await fileRequester.upload(formData)).uploads[0].url;
    // }

    validateInputs(inputsSignUp.current).then(async (result) => {
      if (result.isValid) {
        // data.email = inputsSignUp.current[0].getValue();
        // data.password = inputsSignUp.current[1].getValue();
        // data.first_name = inputsSignUp.current[2].getValue();
        // data.last_name = "";
        // data.phone = inputsSignUp.current[3].getValue();
        // data.businessMutual = inputsSignUp.current[4].getValue();
        // data.businessNumber = inputsSignUp.current[5].getValue();
        // data.businessAddress =
        //   "[" +
        //   inputsSignUp.current[6].getValue() +
        //   "] " +
        //   inputsSignUp.current[7].getValue() +
        //   inputsSignUp.current[8].getValue();
        // data.businessName = inputsSignUp.current[9].getValue();
        // data.businessPhone = inputsSignUp.current[10].getValue();
        // data.businessEmail = inputsSignUp.current[11].getValue();
        // data.businessDetail = inputsSignUp.current[12].getValue();
        // data.businessType = inputsSignUp.current[13].getValue();
        // data.businessCertificate = certificateUrl;
        // data.businessRetail = retailUrl;
        // data.recommender = getRecommenderFromPartnerLink();

        data.email = inputsSignUp.current[0].getValue();
        data.password = inputsSignUp.current[1].getValue();
        data.first_name = inputsSignUp.current[2].getValue();
        data.last_name = "";
        data.phone = inputsSignUp.current[3].getValue();
        data.recommender = getRecommenderFromPartnerLink();

        if (duplicate) {
          toast.error(t("중복확인을 해주세요"), {
            autoClose: 1000,
            position: toast.POSITION.BOTTOM_CENTER,
          });
        } else {
          if (agree) {
            dispatch(HistoryReducer.actions.setLoading(true));
            storeRequester.createCustomer(data, (result) => {
              if (result.customer) {
                // toast.success(t("관리자 승인 이후 로그인이 가능합니다."), {
                //   autoClose: 3000,
                //   position: "top-center",
                // });
                // modal.current.close();
                tabViewRef.current.nextIndex();
              } else {
                toast.error(t("문제가 발생했습니다 관리자에게 문의하세요"), {
                  autoClose: 1000,
                  position: toast.POSITION.BOTTOM_CENTER,
                });
              }
              dispatch(HistoryReducer.actions.setLoading(false));
            });
          } else {
            toast.error(t("agreeToTheTerms"), {
              autoClose: 1000,
              position: toast.POSITION.BOTTOM_CENTER,
            });
          }
        }
      } else {
        toast.error(t("pleaseCheck"), {
          autoClose: 1000,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    });
  };

  const findSelectedProductById = (id) => {
    const key = Object.keys(rowIndex).find(
      (product) => rowIndex[product].id === id
    );
    return rowIndex[key];
  };
  const onCheckGroupCallback = (checkedIndex) => {
    let selectedProducts = [];
    checkedIndex &&
      checkedIndex.map((index) => {
        selectedProducts.push(rowIndex[index]);
      });
    setSelectedList(selectedProducts);
  };

  const addressKrModalClick = () => {
    NiceModal.show("addressKr", { onCallback: addressKrCallback });
    setSignUpData((prev) => ({
      ...prev,
      businessAddress: "",
      businessAddressDetail: "",
      postal_code: "",
    }));
  };
  const addressKrCallback = (dataFromModal) => {


    setSignUpData((prevState) => ({
      ...prevState,
      businessAddress: dataFromModal.address,
      postal_code: dataFromModal.zonecode,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (name === "businessCertificate") {
      setBusinessCertificate(files[0]);
    } else if (name === "businessRetail") {
      setBusinessRetail(files[0]);
    }
  };
  const onDuplicateClick = () => {
    const email = inputsSignUp.current[0].getValue();

    // 이메일 형식 검증
    if (!emailFormat.exp.test(email)) {
      toast.error(t("아이디는 이메일 형식이어야 합니다."), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      inputsSignUp.current[0].setValid(false);
      return;
    }

    // 기존 중복 검사 로직
    storeRequester.isExistEmail(email, (result) => {
      if (result.exists) {
        toast.error(t("duplicateEmail"), {
          autoClose: 1000,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      } else {
        toast.success(t("available"), {
          autoClose: 1000,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
      inputsSignUp.current[0].setValid(!result.exists);
      setDuplicate(result.exists);
    });
  }

  const btnStyle = {
    backgroundColor: "var(--main-color)",
    borderRadius: "0",
    border: "none",
    padding: "0",
    height: "30px",
    width: "130px",
    fontSize: "var(--font-size-lg)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
  };
  const duplicateCheckBtnStyle = {
    backgroundColor: "var(--main-color)",
    borderRadius: "0",
    border: "none",
    padding: "0 10px",
    height: "36px",
    width: "90px",
    fontSize: "var(--font-size)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
  };

  return (
    <ModalBase
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
      borderRadius={0}
      overflow={"hidden"}
    >
      <TabView
        ref={tabViewRef}
        height={"100%"}
        overflowX={"hidden"}
        initTabIndex={props.initTabIndex || 0}
        onTabChange={onTabChange}
        noneMenu
      >
        <TabViewChild tabName={t("privacy")}>
          <VerticalFlex gap={30}>
            {/* =============================================== 개인 정보 입력 section =============================================== */}
            <FlexChild>
              <VerticalFlex>
                <FlexChild position={"sticky"} top={3} zIndex={99}>
                  <div style={{ width: "100%", height: "2px", backgroundColor: "rgba(206, 206, 206, 1)" }} />
                </FlexChild>
                <FlexChild position={"sticky"} top={1} zIndex={99}>
                  <div className={style.headerContainer}>
                    <div className={style.step}>1. 정보입력</div>
                    <div className={style.inactiveStep}>2. 회원가입</div>
                  </div>
                  <Dummy height={"40px"} />
                </FlexChild>
                <FlexChild>
                  <Center width={"100%"} textAlign={"left"}>
                    <Inline>
                      <P weight={"bold"} size={"var(--font-size-lg)"}>
                        {t("privacy")} 입력
                      </P>
                      {/* <P size={"var(--font-size-sm)"}>{"("}</P>
                                            <P size={"var(--font-size-sm)"} color={"var(--main-color)"}>*</P>
                                            <P size={"var(--font-size-sm)"}> RequiredField {")"}</P> */}
                    </Inline>
                  </Center>
                  <Dummy height={"10px"} />
                </FlexChild>
                <FlexChild>
                  <div className={style.titleLine}></div>
                </FlexChild>
                <FlexChild>
                  <HorizontalFlex justifyContent={"flex-start"}>
                    <FlexChild
                      height={130}
                      width={"min(35%, 150px)"}
                      backgroundColor={"var(--user-bg-color)"}
                      padding={"20px"}
                    >
                      <Inline>
                        <P color={"var(--main-color)"}>&nbsp;*</P>
                        <P weight={700}>{" 이메일"}</P>
                      </Inline>
                    </FlexChild>
                    <FlexChild padding={"0 0 0 20px"}>
                      <Flex flexStart direction={isMobile ? "vertical" : null} gap={isMobile ? 0 : 20}>
                        <FlexChild height={40} width={isMobile ? "75%" : "55%"}>
                          <InputText
                            ref={(el) => (inputsSignUp.current[0] = el)}
                            regExp={[emailFormat]}
                            disabled={!duplicate}
                            feedback={isMobile ? "" : "pleaseCheck"}
                            placeHolder={"이메일"}
                          />
                        </FlexChild>
                        <FlexChild>
                          <CustomButton text={"중복확인"} onClick={onDuplicateClick} style={duplicateCheckBtnStyle} />
                        </FlexChild>
                      </Flex>
                    </FlexChild>
                  </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                  <div className={style.line}></div>
                </FlexChild>
                <FlexChild>
                  <HorizontalFlex justifyContent={"flex-start"}>
                    <FlexChild
                      height={180}
                      width={"min(35%, 150px)"}
                      backgroundColor={"var(--user-bg-color)"}
                      padding={"20px"}
                    >
                      <Inline>
                        <P color={"var(--main-color) "}>&nbsp;*&nbsp;</P>
                        <P weight={700}>{t("password")}</P>
                      </Inline>
                    </FlexChild>
                    <FlexChild padding={"0 0 0 20px"}>
                      <VerticalFlex flexStart>
                        <FlexChild height={100} width={isMobile ? "75%" : "55%"}>
                          <InputPassword
                            signUp
                            ref={(el) => (inputsSignUp.current[1] = el)}
                            placeHolder={t("password")}
                            placeHolderComfirm={t("password") + t("confirm")}
                            confirmVisible={true}
                            regExp={[textFormat]}
                          />
                        </FlexChild>
                        {/* <FlexChild>
                          <Center
                            width={"100%"}
                            textAlign={"left"}
                            alignItems={"flex-start"}
                          >
                            <P color={"#ddd"} size={"10pt"}>
                              {t("minimumCharacters")}
                            </P>
                          </Center>
                        </FlexChild> */}
                      </VerticalFlex>
                    </FlexChild>
                  </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                  <div className={style.line}></div>
                </FlexChild>
                <FlexChild>
                  <HorizontalFlex justifyContent={"flex-start"}>
                    <FlexChild
                      height={100}
                      width={"min(35%, 150px)"}
                      backgroundColor={"var(--user-bg-color)"}
                      padding={"20px"}
                    >
                      <Inline>
                        <P color={"var(--main-color)"}>&nbsp;*&nbsp;</P>
                        <P weight={700}>{t("이름")}</P>
                      </Inline>
                    </FlexChild>
                    <FlexChild padding={"0 0 0 20px"}>
                      <VerticalFlex flexStart>
                        <FlexChild height={40} width={isMobile ? "75%" : "20%"}>
                          <InputText

                            placeHolder={t("이름")}
                            ref={(el) => (inputsSignUp.current[2] = el)}
                            regExp={[textFormat]}
                          />
                        </FlexChild>
                      </VerticalFlex>
                    </FlexChild>
                  </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                  <div className={style.line}></div>
                </FlexChild>
                <FlexChild>
                  <HorizontalFlex justifyContent={"flex-start"}>
                    <FlexChild
                      height={100}
                      width={"min(35%, 150px)"}
                      backgroundColor={"var(--user-bg-color)"}
                      padding={"20px"}
                    >
                      <Inline>
                        <P color={"var(--main-color)"}>&nbsp;*&nbsp;</P>
                        <P weight={700}>{t("number")}</P>
                      </Inline>
                    </FlexChild>
                    <FlexChild padding={"0 0 0 20px"}>
                      <VerticalFlex flexStart>
                        <FlexChild height={40} width={isMobile ? "75%" : "35%"}>
                          <InputText
                            placeHolder={t("'-' 없이 입력 ex)01012341234")}
                            ref={(el) => (inputsSignUp.current[3] = el)}
                            regExp={[mobileNoFormat]}
                            numberOnly
                            max={11}
                          />
                        </FlexChild>
                      </VerticalFlex>
                    </FlexChild>
                  </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                  <div className={style.line}></div>
                </FlexChild>
              </VerticalFlex>
            </FlexChild>
            {/* =============================================== 약관 동의 section =============================================== */}
            <FlexChild>
              <VerticalFlex>
                <FlexChild>
                  <Center width={"100%"} textAlign={"left"}>
                    <Inline>
                      <P weight={"bold"} size={"16pt"}>
                        {t("termsOfUse")}
                      </P>
                    </Inline>
                  </Center>
                </FlexChild>
                <FlexChild>
                  <div className={style.titleLine}></div>
                </FlexChild>
                <FlexChild padding={"10px 0 0 0"} overflowX={"hidden"}>
                  <CheckCircleGroup
                    callback={onCheckGroupCallback}
                    header={[
                      {
                        width: "90%",
                        text: `${t("termsOfUse")},${t("privacyPolicy")}${t(
                          "useToInfo"
                        )}, ${t("shoppingInfoAgree")}`,
                        alignItems: "center",
                      },
                    ]}
                  >
                    {rowIndex &&
                      rowIndex.map((data, index) => (
                        <Terms data={data} key={index} index={index} />
                      ))}
                  </CheckCircleGroup>
                </FlexChild>
              </VerticalFlex>
            </FlexChild>
            <FlexChild>
              <HorizontalFlex justifyContent={"center"}>
                <FlexChild height={50} width={"40%"} justifyContent={"center"}>
                  <CButton style={btnStyle} onClick={onNextBtnClick}>
                    {"회원가입"}
                  </CButton>
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
            <FlexChild>
              <Dummy height={50} />
            </FlexChild>
          </VerticalFlex>
        </TabViewChild>
        <TabViewChild tabName={t("accountComplete")}>
          <VerticalFlex>
            <FlexChild position={"sticky"} top={2} zIndex={99}>
              <div style={{ width: "100%", height: "2px", backgroundColor: "rgba(206, 206, 206, 1)" }} />
            </FlexChild>
            <FlexChild position={"sticky"} top={1} zIndex={99}>
              <div className={style.headerContainer}>
                <div className={style.step2}>1. 정보입력</div>
                <div className={style.inactiveStep2}>2. 회원가입</div>
              </div>
              <Dummy height={"40px"} />
            </FlexChild>
            
            <FlexChild>
              <Center width={"100%"} textAlign={"left"}>
                <Inline>
                  <P weight={"bold"} size={"var(--font-size-lg)"}>
                    회원가입 안내
                  </P>
                </Inline>
              </Center>
              <Dummy height={"10px"} />
            </FlexChild>
            <FlexChild>
              <div className={style.titleLine}></div>
            </FlexChild>
            <FlexChild >
              <Dummy height={50} />
              <P size={26} weight="bold">
                <HighlightedText
                  text="관리자가 승인 후"
                  highlights={['관리자', '승인']}
                  highlightColor="#2979ff"
                />
              </P>
              <P size={26} weight={"bold"}>회원가입이 완료 됩니다.</P>
              <Dummy height={30} />
              {/* <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", width: isMobile ? "100%" : "30%", backgroundColor: "#F5F5F5", alignItems: "center" }}>
                <img style={{ margin: "10px", transform: "translateX(3px)" }} src={phoneImg} width={20} />
                <P size={26} weight={"bold"}> 010-2349-8677</P>
              </div> */}
              <Dummy height={15} />
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", width: isMobile ? "100%" : "30%", backgroundColor: "#F5F5F5", alignItems: "center" }}>
                <img style={{ margin: "10px" }} src={messageImg} width={28} />
                <P size={20} weight={"bold"}>puffuofficial@gmail.com</P>
              </div>
              <Dummy height={60} />
              <div style={{ height: "1px", width: "100%", backgroundColor: "#CECECE" }} />
            </FlexChild>
            <FlexChild padding={"30px 0 0 0"}>
              <HorizontalFlex justifyContent={"center"}>
                <FlexChild height={50} width={isMobile ? "50%" : "30%"}>
                  <ButtonEclipse
                    backgroundColor={"var(--main-color)"}
                    // text={t("goShopping")}
                    text={"확인"}
                    // onClick={onShoppingClick}
                    onClick={onShoppingClick}
                    fontSize={24}
                  />
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
          </VerticalFlex>
        </TabViewChild>
      </TabView>
      <input
        ref={inputTabIndex}
        className={"qdqdq"}
        type={"hidden"}
        value={tabIndex || 0}
      />
    </ModalBase>
  );
});

export default MemberSignTabModal;
